import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { BrowserRouter as Router } from 'react-router-dom';
// import '../public/assets/theme.css'
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
 

ReactDOM.render(
    <Router>
        <App />
    </Router>,    
    document.getElementById('root'));
    

